import { render, staticRenderFns } from "./kexie.vue?vue&type=template&id=08d3020a&"
import script from "./kexie.vue?vue&type=script&lang=js&"
export * from "./kexie.vue?vue&type=script&lang=js&"
import style0 from "./kexie.vue?vue&type=style&index=0&id=08d3020a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d3020a')) {
      api.createRecord('08d3020a', component.options)
    } else {
      api.reload('08d3020a', component.options)
    }
    module.hot.accept("./kexie.vue?vue&type=template&id=08d3020a&", function () {
      api.rerender('08d3020a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kexie/kexie.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/kexie/kexie.vue
// module id = D0Xx
// module chunks = 0